import { useRouter } from '@tanstack/react-router'
import posthog from 'posthog-js'
import { useEffect } from 'react'

export function usePageTracking() {
  const router = useRouter()

  useEffect(() => {
    return router.subscribe('onResolved', () => {
      posthog.capture('$pageview', { $current_url: window.location.href })
    })
  }, [router])
}
